import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost, handleChangeValue, handleDateChangeEvent } from '../../../../utils/AxiosUtil';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';
import NewAgainField from '../../../common/inputfields/NewAgainField';
import ErrorAwareAmountField from '../../../common/inputfields/ErrorAwareAmountField';
import { toDateFormat, trimSpaces } from '../../../../utils/Util';
import ErrorAwareDatePicker from '../../../common/inputfields/ErrorAwareDatePicker';
import MyAutocomplete from '../../../common/inputfields/MyAutocomplete';
import axios from 'axios';
import * as enums from '../../../../utils/EnumMapping';

class NewCarInsurance extends Component {

    state = {
        selectedBill: this.props.row.rowType === 'INCOMING_BILL' ? { label: this.props.row.publicId + ' - ' + this.props.row.customerName, value: this.props.row.privateId } : null,
        selectedCar: this.props.row.rowType === 'CAR' ? { label: this.props.row.licenseNumber, value: this.props.row.privateId } : null,
        selectedInsuranceType: enums.insuranceTypes[0],
        startDate: new Date(),
        endDate: new Date(),
        description: '',
        errors: new Map(),
    }

    handleSubmit = async (event) => {
        console.log(this.props.row);
        event.persist()
        event.preventDefault();
        const path = '/api/carinsurance';
        const requestObject = {
            "billId": this.state.selectedBill.value,
            "carId": this.state.selectedCar.value,
            "insuranceType": this.state.selectedInsuranceType.value,
            "startDate": this.state.startDate,
            "endDate": this.state.endDate,
            "description": this.state.description,
        };
        console.log(requestObject);
        await handlePost(path, requestObject, this);
    };

    promiseCarOptions = async () => {
        const response = await axios.get('/api/cars')
        return response.data.map(resp => ({
            label: resp.licenseNumber,
            value: resp.privateId
        }));
    };

    handleCarSelected = (e, v) => {
        console.log(v);
        this.setState({ selectedCar: v })
    }

    promiseBillOptions = async () => {
        const response = await axios.get('/api/incomingbillsDigest')
        return response.data.map(resp => ({
            label: resp.publicId + ' - ' + resp.customerName,
            value: resp.privateId
        }));
    };

    handleBillSelected = (e, v) => {
        console.log(v);
        this.setState({ selectedBill: v })
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <MyAutocomplete
                            value={this.state.selectedCar}
                            defaultvale={this.state.selectedCar}
                            getOptions={this.promiseCarOptions}
                            onChange={this.handleCarSelected}
                            label={'Autó'}
                            disabled={this.props.row.rowType === 'CAR'}
                        />
                    </div>
                    <div className='input-group'>
                        <MyAutocomplete
                            value={this.state.selectedBill}
                            defaultvale={this.state.selectedBill}
                            getOptions={this.promiseBillOptions}
                            onChange={this.handleBillSelected}
                            label={'Számla'}
                            disabled={this.props.row.rowType === 'INCOMING_BILL'}
                        />
                    </div>
                    <div className='input-group'>
                        <FormControl variant="outlined" fullWidth required>
                            <InputLabel id="insurance-type-label">Biztosítás típusa</InputLabel>
                            <Select
                                name="selectedType"
                                labelId="insurance-type-label"
                                id={this.props.name}
                                value={this.state.selectedInsuranceType}
                                onChange={e => handleChangeEvent(e, this)}
                                label="Biztosítás típusa">
                                {enums.insuranceTypes.map((value, index) =>
                                    <MenuItem key={index} value={value}>{value.label}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="comment"
                            label="Leírás"
                            value={this.state.description}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            required
                            id="startDate"
                            name="startDate"
                            label="Kezdő dátum"
                            errors={this.state.errors}
                            value={this.state.startDate}
                            onChange={v => handleDateChangeEvent(v, "startDate", this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            required
                            id="endDate"
                            name="endDate"
                            label="Vége dátum"
                            errors={this.state.errors}
                            value={this.state.endDate}
                            onChange={v => handleDateChangeEvent(v, "endDate", this)}
                        />
                    </div>
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(NewCarInsurance);
